module.exports = __webpack_public_path__ + "media/img/baercode-phone-32e928d2a054a32b1b52a32111443079.png";